import React, { FC } from 'react';
import { useParams } from 'react-router';

import _ from '../../locale';
import { styled } from '../../theme';
import { Button, FlexRow } from '../index';

const Wrapper = styled(FlexRow)(({ theme }) => ({
    paddingRight: 30,
    height: 80,
    backgroundColor: theme?.color?.gray90,
    fontSize: 16,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme?.zIndex?.modal + 1,
}));

const StyledButton = styled(Button)({
    minHeight: 40,
    height: 40,
});

const BackToEditButton = styled(StyledButton)({
    background: 'none',
});

type Props = {
    onHide: () => void;
    onSubmit: () => void;
};

const SurveyPreviewBanner: FC<Props> = ({ onHide, onSubmit }) => {
    const { id } = useParams();
    const isEditMode = Boolean(id);

    return (
        <Wrapper align="center" justify="flex-end" itemsSpacing={16}>
            <BackToEditButton color="base" onClick={onHide}>
                {_('back_to_edit_button')}
            </BackToEditButton>
            <StyledButton color="primary" onClick={onSubmit}>
                {isEditMode ? _('save_survey_button') : _('create_survey_button')}
            </StyledButton>
        </Wrapper>
    );
};

export default SurveyPreviewBanner;
